export var LOCATIONS_CONTEXT = 'LOCATIONS_CONTEXT';
export var LBS_PAGE_SIZE = 10000;
export var MAP_API_KEYS = {
    development: 'AIzaSyAFzHjUExEnVkUn-MIHam7b9qbSYMqH8iE',
    'non-development': 'AIzaSyAs7Q-KjIA0PNb-8Gndg34CVCUAQv6VJ5c',
};
var ANALYTICS_PREFIX = 'locations.';
var LOCATION_PICKER_PREFIX = "".concat(ANALYTICS_PREFIX, "picker_component.");
export var LOCATION_PICKER_ANALYTIC_EVENTS = {
    OPEN: "".concat(LOCATION_PICKER_PREFIX, "open"),
    INCLUDE_SUB_ITEMS: "".concat(LOCATION_PICKER_PREFIX, "include_sub_items"),
    SELECT_NODE: "".concat(LOCATION_PICKER_PREFIX, "select_node"),
    CLEARED_CLICKED: "".concat(LOCATION_PICKER_PREFIX, "clear_clicked"),
};
export var LOCATION_PICKER_ANALYTICS_ACTIONS = {
    ASSIGNED: 'assigned',
    UPDATED: 'updated',
    CLEARED: 'cleared',
};
export var MAX_SELECTED_NODES = 10;
